export default {
  title: '用户登录',
  username: '请输入用户名',
  password: '请输入密码',
  login: '登录',
  forgetPass: '忘记密码',
  resources: '资源下载',
  phone: '请输入手机号',
  retrievePass: '重置密码',
  newpass: '请输入新密码',
  RepeatPass: '请重复密码',
  getCode: '获取验证码',
  submit: '提交',
  return: '返回登录',
  errLog: '是否导出服务器日志',
  qdtc: '确定注销登录, 是否继续?',
  keycode: "请输入验证码",
  systemVersion: "系统版本",
  show: "显示"
}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh/Login.js